import React from 'react';
import { Routes as Switch, Route, BrowserRouter as Router, Navigate } from 'react-router-dom';
import Tutorial from 'pages/tabs/Tutorial';
import ChooseAction from 'pages/modals/ChooseAction';
import Recognize from 'pages/modals/Recognize';
import Inactive from 'pages/modals/Inactive';
import AwardBonus from 'pages/modals/AwardBonus';
import AddCelebrationDates from 'pages/modals/AddCelebrationDates';
import Pulse from 'pages/modals/Pulse';
import ViewResponses from 'pages/modals/Pulse/ViewResponses';
import SuggestionBox from 'pages/modals/SuggestionBox';
import ReplyAnonymously from 'pages/modals/SuggestionBox/ReplyAnonymously';
import EditSuggestion from 'pages/modals/SuggestionBox/EditSuggestion';
import FeedbackSelection from 'pages/modals/360Feedback';
import RequestFeedback from 'pages/modals/360Feedback/RequestFeedback';
import SendFeedback from 'pages/modals/360Feedback/SendFeedback';
import Intros from 'pages/modals/IntroForm';
import ModuleGuard from 'components/ModuleGuard';
import { MODULES } from 'constants.js';

const guarded = (module, element) => <ModuleGuard module={module}>{element}</ModuleGuard>;

const Index = () => (
    <Router>
        <Switch>
            <Route exact path='/tabs/tutorial' element={<Tutorial />} />
            <Route exact path='/modals/choose-action' element={<ChooseAction />} />
            <Route exact path='/modals/recognize' element={guarded(MODULES.RNR, <Recognize />)} />
            {/* No ModuleGuard: the bot opens this modal without a token; Celebrations is gated bot-side (Teams bot task/fetch). */}
            <Route exact path='/modals/addCelebrationDates' element={<AddCelebrationDates />} />
            <Route exact path='/modals/inactive' element={<Inactive />} />
            <Route exact path='/modals/bonus' element={guarded(MODULES.BONUS, <AwardBonus />)} />
            <Route exact path='/modals/pulse/startAnswer' element={guarded(MODULES.ORG_HEALTH, <Pulse />)} />
            <Route exact path='/modals/pulse/viewResponse' element={guarded(MODULES.ORG_HEALTH, <ViewResponses />)} />
            <Route exact path='/modals/suggestion-box' element={guarded(MODULES.SUGGESTION_BOX, <SuggestionBox />)} />
            <Route
                exact
                path='/modals/suggestion-box/reply-anonymously'
                element={guarded(MODULES.SUGGESTION_BOX, <ReplyAnonymously />)}
            />
            <Route
                exact
                path='/modals/suggestion-box/edit'
                element={guarded(MODULES.SUGGESTION_BOX, <EditSuggestion />)}
            />
            <Route exact path='/modals/feedbackSelection' element={guarded(MODULES.FEEDBACK, <FeedbackSelection />)} />
            <Route exact path='/modals/sendFeedback' element={guarded(MODULES.FEEDBACK, <SendFeedback />)} />
            <Route exact path='/modals/requestFeedback' element={guarded(MODULES.FEEDBACK, <RequestFeedback />)} />
            <Route exact path='/modals/intros' element={guarded(MODULES.NEW_HIRE_ONBOARDING, <Intros />)} />
            <Route path='*' element={<Navigate replace to='/tabs/tutorial' />} />
        </Switch>
    </Router>
);

export default Index;
